<template>
  <div class="container">
    <br>
    <div class="columns is-centered is-multiline">
      <div class="column is-half" v-for="type in ObjectTypes" :key="type">
        <router-link :to="$entity.toSearchRoute(type)" class="box title">
          {{ type | toTitleCase }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'

export default {
  name: 'SearchOverview',

  computed: {
    ObjectTypes () {
      return Library.Entities.getSearchableEntities()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/sass/bulma.scss';

  .box {
    text-align: center;
    padding: 4rem 2rem;
    transition: all .3 ease;

    &:hover {
      @extend .button.is-link;
      cursor: pointer;
    }
  }
</style>
